import { MutexLock } from 'utils/mutexLock'

export const billingLock = new MutexLock()
